import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { SpeciesViewControllerDelegate, SpeciesViewController } from "../../Screen/Species/SpeciesViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { SpeciesViewModel } from '../../Screen/Species/SpeciesViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class SpeciesCoordinator implements IndexCoordinatorDelegate, SpeciesViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepdengueespecie")
        return (<ProtectedRoute requiredPermissions={['dengue.especies.*']} path="/:base/dengue/especies" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.especies.adicionar',
                    edit: 'dengue.especies.editar',
                    delete: 'dengue.especies.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Espécies"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new SpeciesViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.especies.adicionar', 'dengue.especies.editar']} path="/:base/dengue/especies/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<SpeciesViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepdengueespecie") {
            navigation.history.push(`especies/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepdengueespecie") {
            navigation.history.push(`especies/cad/${idSelection}`);
            return;
        }
    }

}